<template>
  <div id="aposentadoriaWrapper">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres titulo="Aposentadorias" :voltar="true" breakpoint="xl" />
      </template>
      <b-card-body>
        <CardFiltrosBusca class="mb-2">
          <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(filtrarAposentadorias)">
              <b-container fluid>
                <b-row class="m-2 d-flex justify-content-center">
                  <b-col cols="12" sm="4" xl="4" class="px-xl-2 px-sm-2 px-0">
                    <default-form-validation-provider label="Nome ou CPF do aposentado:" v-slot="defaultState"
                      rules="min:4">
                      <b-form-input size="sm" id="input-nome-cpf" v-model="valorInputNomeCPF"
                        :state="defaultState.state" />
                    </default-form-validation-provider>
                  </b-col>

                  <b-col cols="12" sm="4" xl="4" class="px-xl-2 px-sm-2 px-0">
                    <default-form-validation-provider label="CPF Cadastro:" v-slot="defaultState" rules="min:11">
                      <b-form-input size="sm" id="input-cpf-usuario" :state="defaultState.state"
                        v-model="valorCPFUsuario" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" sm="4" xl="4" class="px-xl-2 px-sm-2 px-0">
                    <default-form-validation-provider label="Órgão:" v-slot="defaultState" rules="min:4">
                      <b-form-input size="sm" id="input-orgao" v-model="valorOrgao" :state="defaultState.state" />
                    </default-form-validation-provider>
                  </b-col>

                  <b-col cols="12" sm="4" xl="4" class="px-xl-2 px-sm-2 px-0">
                    <default-form-validation-provider label="Situação:" size="sm" rules="">
                      <b-form-radio-group v-model="valorDropdown" :options="textosDropDown" buttons />
                      <!-- <b-form-select id="situacao" v-model="valorDropdown" :options="textosDropDown">
                      </b-form-select> -->
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" sm="4" xl="4" class="px-xl-2 px-sm-2 px-0">
                    <default-form-validation-provider label="Data de Envio:" size="sm" rules="">
                      <DateRangePickerBase v-model="dataEnvio" />
                    </default-form-validation-provider>
                  </b-col>
                </b-row>
                <b-row class="m-2 d-flex justify-content-center">
                  <b-col cols="auto" class="mx-2 my-1 my-xl-0">
                    <b-button size="sm" @click="limparFiltro">
                      <font-awesome-icon icon="redo" class="mr-1" />
                      Limpar</b-button>
                  </b-col>
                  <b-col cols="auto" class="mx-2 my-1 my-xl-0">
                    <b-button size="sm" type="submit"><font-awesome-icon icon="magnifying-glass" class="mr-1" />
                      Buscar
                    </b-button>
                  </b-col>
                </b-row>
              </b-container>
            </b-form>
          </validation-observer>
        </CardFiltrosBusca>
        <b-overlay :show="carregandotabela">
          <b-table striped hover stacked="lg" show-empty :items="listaAposentadorias" :fields="computedFields"
            :current-page="currentPage">
            <template #empty>
              <span>Não foram encontrados resultados.</span>
            </template>
            <template #cell(DtExclusao)="data">
              {{ formatAtivo(data.item.DtExclusao) }}
            </template>
            <template #cell(DtCriacao)="data">
              {{ formatDataHora(data.item.DtCriacao) }}
            </template>
            <template #cell(acao)="data">
              <div class="actions-icons lgvert d-none d-sm-flex">
                <b-link class="text-dark" @click="abrirModal(data.item.IdAposentadoria)">
                  <font-awesome-icon icon="eye" />
                  <div class="text-nowrap" style="font-size: 12px">Detalhes</div>
                </b-link>
              </div>
            </template>
          </b-table>
          <table-pagination v-if="totalRows" :total-rows="totalRows" per-page="10" @pageChange="novaPagina">
          </table-pagination>
        </b-overlay>
      </b-card-body>
    </b-card>
    <b-modal id="modal-aposentadoria" scrollable header-bg-variant="secondary" header-text-variant="light" size="xl">
      <template #modal-title>
        <span v-html="computedTitle"></span>
      </template>
      <div class="container">
        <b-tabs card class="m-1">
          <b-tab title="Dados do Aposentado">
            <AbaDadosIniciais :aposentadoria="aposentadoria" />
          </b-tab>

          <b-tab title="Tempo de Contribuição">
            <AbaTempoContribuicao :aposentadoria="aposentadoria" />
          </b-tab>

          <b-tab title="Proventos">
            <AbaProventos :aposentadoria="aposentadoria" />
          </b-tab>

          <b-tab title="Arquivos">
            <AbaArquivosAposentadoria :aposentadoria="aposentadoria" />
          </b-tab>
        </b-tabs>
      </div>

      <template #modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()"> Fechar </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import CardFiltrosBusca from "@/components/shared/CardFiltrosBusca.vue";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import { TableField } from "@/types/table-field";
import aposentadoriaService from "@/services/atos-pessoal/aposentadoriaService";
import { store } from "@/store";

import { Aposentadoria } from "@/types/aposentadoria/aposentadoria";
import { FiltroAposentadorias } from "@/types/aposentadoria/filtro-aposentadorias";
import DateRangePickerBase from "@/components/shared/DateRangePickerBase.vue";

import AbaArquivosAposentadoria from "@/components/atos-pessoal/aposentadorias/AbaArquivosAposentadoria.vue";
import AbaDadosIniciais from "@/components/atos-pessoal/aposentadorias/AbaDadosIniciais.vue";
import AbaTempoContribuicao from "@/components/atos-pessoal/aposentadorias/AbaTempoContribuicao.vue";
import AbaProventos from "@/components/atos-pessoal/aposentadorias/AbaProventos.vue";
import { ValidationObserver } from "vee-validate";

const dataEnvioPadrao = {
  startDate: new Date(new Date().getFullYear(), 0, 1),
  endDate: new Date(new Date().getFullYear(), 11, 31),
};

const CompProps = Vue.extend({
  name: "Aposentadorias",
  components: {
    HeaderSagres,
    CardFiltrosBusca,
    DateRangePickerBase,
    DefaultFormValidationProvider,
    AbaArquivosAposentadoria,
    AbaDadosIniciais,
    AbaTempoContribuicao,
    AbaProventos,
    TablePagination,
    ValidationObserver,
  },
});

@Component
export default class Aposentadorias extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  //overlays e controles de estado
  carregandotabela = false;
  //listas e variáveis
  listaAposentadorias: Aposentadoria[] = [];
  aposentadoria: Aposentadoria = new Aposentadoria({});

  //Variáveis para a paginação
  totalRows = 0;
  currentPage = 1;

  //Inputs do filtro
  valorInputNomeCPF = "";
  valorNomeAposentado = "";
  valorCPFAposentado = "";
  valorCPFUsuario = "";
  valorOrgao = "";
  dataEnvio = { ...dataEnvioPadrao };
  valorDropdown = "ativo";
  inputFiltro: FiltroAposentadorias;
  //Computeds
  get computedTitle(): string {
    return `Processo: ${this.aposentadoria.NrProcesso}`;
  }

  //Dados para o dropdown
  textosDropDown = [
    { value: "", text: "Todos" },
    { value: "ativo", text: "Ativo" },
    { value: "cancelado", text: "Cancelado" },
  ];

  //computeds
  get computedFields(): TableField[] {
    const fields: TableField[] = [
      {
        key: "NrCpf",
        label: "CPF",
        thClass: "naoQuebrar",
        tdClass: "quebrarPorPalavraHard",
      },
      {
        key: "NmAposentado",
        label: "Nome do Aposentado",
        thClass: "quebrarPorPalavraHard",
        tdClass: "quebrarPorPalavraHard",
      },
      {
        key: "DeOrgaoAposentadoria",
        label: "Órgão",
        tdClass: "quebrarPorPalavraHard",
        thClass: "naoQuebrar",
      },
      {
        key: "NrProcesso",
        label: "Processo",
        thClass: "naoQuebrar",
        tdClass: "quebrarPorPalavraHard",
      },
      {
        key: "CdProtocoloTce",
        label: "Protocolo E-TCE",
        thClass: "quebrarPorPalavraHard",
        tdClass: "quebrarPorPalavraHard",
      },
      {
        key: "DtCriacao",
        label: "Data de Envio",
        thClass: "quebrarPorPalavraHard",
        tdClass: "quebrarPorPalavraHard",
      },
      {
        key: "DtExclusao",
        label: "Ativo",
        thClass: "naoQuebrar",
        tdClass: "quebrarPorPalavraHard",
      },
      {
        key: "CpfUsuario",
        label: "CPF de Cadastro",
        thClass: "quebrarPorPalavraHard",
        tdClass: "quebrarPorPalavraHard",
      },
      {
        key: "acao",
        label: "Ações",
        thClass: "naoQuebrar",
      },
    ];
    return fields;
  }

  mounted() {
    this.carregarAposentadorias();
  }

  async carregarAposentadorias() {
    let filtro: FiltroAposentadorias = {
      NomeAposentado: this.valorNomeAposentado,
      CpfAposentado: this.valorCPFAposentado,
      CpfUsuario: this.valorCPFUsuario,
      DtEnvioInicio: this.formatDataDB(this.dataEnvio.startDate),
      DtEnvioFim: this.formatDataDB(this.dataEnvio.endDate),
      Orgao: this.valorOrgao,
      Ativo:
        this.valorDropdown === "ativo"
          ? true
          : this.valorDropdown === "cancelado"
            ? false
            : undefined,
      Page: this.currentPage,
      PageSize: 10,
    };

    try {
      this.carregandotabela = true;
      this.listaAposentadorias = [];

      const response = await aposentadoriaService.listarAposentadorias(filtro);
      this.listaAposentadorias = response.data.map(
        (ap: any) => new Aposentadoria(ap)
      );
      this.totalRows = response.totalRows;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.carregandotabela = false;
    }
  }

  //Filtra as aposentadorias a serem exibidas
  async filtrarAposentadorias(event: Event) {
    const isValid = await this.validationobserver.validate();
    if (!isValid) {
      console.error(this.validationobserver);
    } else {
      this.verificaTexto(this.valorInputNomeCPF);
      this.carregarAposentadorias();
    }
  }

  //Limpa os campos dos filtros
  limparFiltro() {
    this.valorInputNomeCPF = "";
    this.valorNomeAposentado = "";
    this.valorCPFAposentado = "";
    this.valorCPFUsuario = "";
    this.valorOrgao = "";
    this.dataEnvio = { ...dataEnvioPadrao };
    this.valorDropdown = "ativo";
  }

  //Função feita para verificar se o valor do input Nome ou CPF são letras ou números
  verificaTexto(texto: string) {
    if (texto === "") {
      this.valorCPFAposentado = texto;
      this.valorNomeAposentado = texto;
    }

    const isNumeric = (string: string) => Number.isFinite(+string);
    if (isNumeric(texto)) {
      this.valorCPFAposentado = texto;
    } else {
      this.valorNomeAposentado = texto;
    }
  }

  // Método para formatar o valor booleano Ativo
  formatAtivo(dtExclusao: string | null): string {
    if (dtExclusao === "") return "Sim";
    else return "Não";
  }

  novaPagina(page): void {
    this.currentPage = page;
    this.carregarAposentadorias();
  }

  //Modal
  async abrirModal(id: number) {
    //requisição para chamar aposentadoria por id
    try {
      store.blockScreen = true;
      const response = await aposentadoriaService.obterAposentadoriaPorId(id);
      this.aposentadoria = response;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
    this.$bvModal.show("modal-aposentadoria");
  }
}
</script>
